var map = {
	"./config.dev.json": 158,
	"./config.prod.json": 159,
	"./config.test.json": 160
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 157;


//////////////////
// WEBPACK FOOTER
// ./src/config ^\.\/config\..*\.json$
// module id = 157
// module chunks = 0